import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RcSteps, { Step, StepGroup } from '../rc-components/steps';
import { getPrefixCls } from '../configure';
export default class Steps extends Component {
    render() {
        const { props } = this;
        return React.createElement(RcSteps, Object.assign({}, props, { prefixCls: getPrefixCls('steps', props.prefixCls) }));
    }
}
Steps.displayName = 'Steps';
Steps.Step = Step;
Steps.StepGroup = StepGroup;
Steps.defaultProps = {
    iconPrefix: 'icon',
    current: 0,
};
Steps.propTypes = {
    prefixCls: PropTypes.string,
    iconPrefix: PropTypes.string,
    current: PropTypes.number,
};
